

export enum ESlotType {
  Supervision = 'SUPERVISION',
  Personal = 'PERSONAL_CONSULTATION',
}